import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('jsx-overpayment-declaration') as HTMLElement);
root.render(<App />);
